import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { MatDialogModule } from '@angular/material/dialog'
import { MatProgressBarModule } from '@angular/material/progress-bar'
import { MatTooltipModule } from '@angular/material/tooltip'
import { PipesModule } from '@mmx/pipes'
import { TranslateModule } from '@ngx-translate/core'

import { PatientAuthHistoryDialogComponent } from './patient-auth-history-dialog.component'

@NgModule({
  imports: [
    CommonModule,
    MatDialogModule,
    MatProgressBarModule,
    MatTooltipModule,
    PipesModule,
    TranslateModule,
  ],
  declarations: [
    PatientAuthHistoryDialogComponent,
  ],
})
export class PatientAuthHistoryDialogModule {}
